import { onBeforeUnmount, ref, Ref, watch, getCurrentInstance, onMounted } from 'vue';

interface Props {
  isSelected: boolean;
  options: any;
  selectValue: any;
  label: string;
  placeholder: string;
  idColumn: string;
}

export default function useSelectColumn(props: Props) {
  const vm = getCurrentInstance()?.proxy;

  const selectedValue: Ref<string> = ref('');
  const isOpenOption: Ref<boolean> = ref(false);
  const optionList: Ref<Record<string, any>> = ref([]);

  const onCreateColumnActive = () => {
    optionList.value = props.options.filter((col: Record<string, any>) => col.is_display === true);
  };

  const selectedItemColumn = (item: Record<string, any>) => {
    selectedValue.value = item[props.label];
    isOpenOption.value = false;
    vm?.$emit('on-selected', JSON.parse(JSON.stringify(item)));
  };

  const onClickOutsideMenu = (event: Event) => {
    const ListGroup = document.querySelectorAll(`#${props.idColumn}`);
    ListGroup.forEach((el: Element) => {
      const ListGroup = (<HTMLInputElement>el).contains(event.target as HTMLInputElement);

      if (!ListGroup) {
        isOpenOption.value = false;
      }
    });
  };

  onMounted(() => {
    onCreateColumnActive();
    selectedValue.value = props.selectValue[props.label];
    window.addEventListener('click', onClickOutsideMenu);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('click', onClickOutsideMenu);
  });

  watch(
    () => props.selectValue,
    () => {
      selectedValue.value = props.selectValue[props.label];
    },
    { deep: true },
  );

  return {
    optionList,
    selectedValue,
    isOpenOption,
    selectedItemColumn,
  };
}
